import React from "react";
import { useState } from "react";

import base from "../../images/taxsheets/base.svg";
import top1 from "../../images/taxsheets/top1.svg";
import topExcel from "../../images/taxsheets/top-excel.svg";

import baseDashs from "../../images/taxdashs/base.svg";
import topDashs from "../../images/taxdashs/top.svg";

import logoTaxDashs from "../../images/taxdashs/Logo_TaxDashs.png";
import logoTaxSheets from "../../images/taxsheets/Logo_TaxSheets.png";

import * as S from "./style";
import Button from "../../DesignSystem/Button";
import { navigate } from "gatsby";

export default function ProductCard({ product, fluid, className }) {
  const [isHover, setIsHover] = useState(false);

  return (
    <S.Card className={className} $fluid={fluid}>
      {product === "taxsheets" ? (
        <>
          <div className="taxsheets-animate">
            <img src={base} alt="" className="base" />
            <img src={topExcel} alt="" className="topExcel" />
            <img src={top1} alt="" className="top1" />
          </div>
          <div>
            <img className="logo" src={logoTaxSheets} alt="Logo do TaxSheets" />
            <h3>Leitor e Editor de SPED</h3>
            <p>
              Transforme arquivos fiscais do SPED em planilhas editáveis
              do Excel e dê um salto na sua produtividade.
            </p>
            {/* <Button size="big" fluid flat color="secondary">
              Conheça a soluçãooo
            </Button> */}
            <a
              href="/taxsheets"
              className="demonstracao only-desktop"
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              style={{
                padding: "12px 40px",
                border: "none",
                borderRadius: "0px 12px",
                fontSize: "16px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "200ms ease-out",
                width: "auto",
                margin: "0px",
                display: "flex",
                backgroundColor: isHover ? "rgb(60, 255, 150)" : "rgb(0, 69, 142)",
                color: isHover ? "rgb(0, 69, 142)" : "rgb(60, 255, 150)",
                textDecoration: "none"
              }}
            >
      Conheça a solução
    </a>
          </div>
        </>
      ) : (
        <>
          <div className="taxdashs-animate">
            <img src={baseDashs} alt="" className="baseDashs" />
            <img src={topDashs} alt="" className="topDashs" />
          </div>
          <div>
            <img className="logo" src={logoTaxDashs} alt="Logo do TaxDashs" />
            <h3>BI para Tax</h3>
            <p>
              Visualize as suas informações fiscais em relatórios interativos no
              Power BI e obtenha insights valiosos para sua empresa.
            </p>
            {/* <Button size="big" fluid flat color="secondary">
              Conheça a solução
            </Button> */}
            <a
              href="/taxdashs"
              className="demonstracao only-desktop"
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              style={{
                padding: "12px 40px",
                border: "none",
                borderRadius: "0px 12px",
                fontSize: "16px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "200ms ease-out",
                width: "auto",
                margin: "0px",
                display: "flex",
                backgroundColor: isHover ? "rgb(60, 255, 150)" : "rgb(0, 69, 142)",
                color: isHover ? "rgb(0, 69, 142)" : "rgb(60, 255, 150)",
                textDecoration: "none"
              }}
            >
      Conheça a solução
    </a>
          </div>
        </>
      )}
    </S.Card>
  );
}
